export default __webpack_public_path__ + "static/media/help.2b6435cd.svg";